// @flow
import * as React from 'react';
import UserInviteForm from './UserInviteForm';

type Params = {
  organisationId: number,
  context: string
};

type Props = {
  params: Params,
  currentOrganisation: Object,
  currentLocation: ?Object,
  router: Object,
  getUserSettings: (oid: number) => void,
  addOrInviteUser: (u: Object, s: Object, oid: number, c: string) => Promise<*>
};

type State = {
  isSaving: boolean,
  message?: string,
  messageType?: string
};

class UserInvitation extends React.Component<Props, State> {
  timeoutId: any;
  static displayName = 'UserInvitation';

  constructor(props: Props) {
    super(props);
    this.state = {
      isSaving: false
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    const { organisationId } = this.props.params;
    this.props.getUserSettings(organisationId);
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  handleSubmit = (values: Object) => {
    this.setState({ isSaving: true });
    const {
      addOrInviteUser,
      currentOrganisation: { userSettings },
      params: { organisationId, context }
    } = this.props;

    const orgId = parseInt(organisationId, 10);

    addOrInviteUser(values, userSettings, orgId, context).then(
      userId => {
        // display message
        this.setState({
          message: `${values.email} has been invited.`,
          messageType: 'success',
          isSaving: false
        });

        // redirect to userDetail page after 3 seconds
        this.timeoutId = setTimeout(() => {
          this.props.router.push(`/${context}/${orgId}/users/${userId}`);
        }, 3000);
      },
      error => {
        // display message
        this.setState({
          message: error.data.message,
          messageType: 'danger',
          isSaving: false
        });
      }
    );
  };

  currentOrgByContext = () => {
    const {
      params: { context },
      currentOrganisation = {},
      currentLocation = {}
    } = this.props;
    switch (context) {
      default:
      case 'global':
        return undefined;
      case 'customer':
        return currentOrganisation;
      case 'sub-account':
        return currentLocation;
    }
  };

  render() {
    const { organisationId } = this.props.params;
    const currentOrganisation = this.currentOrgByContext();
    return (
      <UserInviteForm
        onSubmit={this.handleSubmit}
        organisationId={organisationId}
        message={this.state.message}
        messageType={this.state.messageType}
        isSaving={this.state.isSaving}
        currentOrganisation={currentOrganisation}
        initialValues={{}}
        enableReinitialize
      />
    );
  }
}

export default UserInvitation;



// WEBPACK FOOTER //
// ./src/containers/users/UserInvitation.js